import Vue from 'vue';
const Locations = {
  state: {
    Locations: [],
  },

  getters: {
    Locations(state) {
      return state.Locations;
    },
  },

  mutations: {
    getLocations(state, payload) {
      if(state.Locations.length == 0){
        state.Locations = payload;
      }
    },
    addLocation(state, payload) {
      payload.ID = state.Locations.length+1
      state.Locations.push(payload)
    },
    editLocation(state, payload){
      state.Locations[payload.ID-1] = payload
    }
  },

  actions: {
    getLocations(context, payload) {
      let data = [
        {ID: 1, Name: 'Emerson', Location: { Address: '324 Buzz Ln, Cheyenne, WY', Latitude: '213456789', Longitude: '-456789123' } , IsFavorite: true}, 
        {ID: 2, Name: 'Hathaway', Location: { Address: '765 Random Ave, Laramie, WY', Latitude: '456789123', Longitude: '-987456321' }, IsFavorite: false},
        {ID: 3, Name: 'Rodgers', Location: { Address: '3432 That Way, Rawlins, WY', Latitude: '456987321', Longitude: '-456321789' }, IsFavorite: false},
      ]
      context.commit('getLocations', data);
    },
    updateLocations(context, payload){
      context.commit('editLocation', payload)
      context.dispatch('getLocations')
    },
    createLocations(context, payload){
      context.commit('addLocation', payload)
      context.dispatch('getLocations')
    },
    deleteLocations(context, payload){
      Locations.state.Locations.splice(payload.ID-1, 1)
      context.dispatch('getLocations')
    }
  },
}

export default Locations